

import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './Register.css';

function Registertea() {
  const navigate = useNavigate();
  const dropdownRef = useRef();

  const [formData, setFormData] = useState({
    date: '', time: '', name: '', area: '', tare: 8,
    water: 0, stick: 0, price: 21, empid: '',
    farmid: '', netweight: 0, ph: ''
  });

  const [qtyList, setQtyList] = useState([{ qty: '' }]);
  const [farmers, setFarmers] = useState([]);
  const [employeeName, setEmployeeName] = useState('');
  const [farmerQuery, setFarmerQuery] = useState('');
  const [showFarmerDropdown, setShowFarmerDropdown] = useState(false);
  const [previousStatus, setPreviousStatus] = useState('');


  useEffect(() => {
    const fetchFarmers = async () => {
      try {
        const response = await fetch('https://kmtea.onrender.com/farmers');
        const data = await response.json();
        setFarmers(data);
      } catch (error) {
        console.error('Failed to fetch farmers:', error);
      }
    };

    const emp = localStorage.getItem('user');
    if (emp) {
      const parsed = JSON.parse(emp);
      const today = new Date().toISOString().split('T')[0];
      setFormData(prev => ({ ...prev, empid: parsed.empid, date: today }));
      setEmployeeName(parsed.empname);
    } else {
      alert('Please log in first');
      navigate('/');
    }

    fetchFarmers();
  }, [navigate]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowFarmerDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const roundSpecial = (value) => {
    const decimal = value - Math.floor(value);
    return decimal >= 0.75 ? Math.ceil(value) : Math.floor(value);
  };

  const recalculate = (qtyArray) => {
    const totalQty = qtyArray.reduce((sum, item) => sum + parseFloat(item.qty || 0), 0);
    const tareOnly = roundSpecial((parseFloat(formData.tare || 0) / 100) * totalQty);
    const water = parseFloat(formData.water || 0);
    const stick = parseFloat(formData.stick || 0);
    const netWeight = totalQty - (tareOnly + water + stick);
    const totalAmount = parseFloat(formData.price) * (isNaN(netWeight) ? 0 : netWeight);

    setFormData(prev => ({
      ...prev,
      qty: totalQty,
      netweight: isNaN(netWeight) ? 0 : netWeight,
      totalamount: isNaN(totalAmount) ? 0 : totalAmount
    }));
  };

  const handleQtyChange = (index, value) => {
    const updated = [...qtyList];
    updated[index].qty = value;
    setQtyList(updated);
    recalculate(updated);
  };

  const addQtyField = () => setQtyList([...qtyList, { qty: '' }]);
  const removeQtyField = (index) => {
    if (qtyList.length === 1) return;
    const updated = qtyList.filter((_, i) => i !== index);
    setQtyList(updated);
    recalculate(updated);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };



const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toISOString().split('T')[0]; // Returns "YYYY-MM-DD"
};

// Inside your component
const handleFarmerSelect = async (farmer) => {
  setFormData(prev => ({
    ...prev,
    name: farmer.name,
    area: farmer.area,
    ph: farmer.ph,
    farmid: farmer.farmid
  }));
  setFarmerQuery(farmer.name);
  setShowFarmerDropdown(false);

  try {
    const res = await fetch('https://kmtea.onrender.com/collecttea');
    const allCollections = await res.json();
    const selectedDate = formData.date;

    const matched = allCollections.find(entry =>
      entry.farmid === farmer.farmid &&
      formatDate(entry.date) === formatDate(selectedDate)
    );

    if (matched) {
      let bags = [];

      try {
        bags = matched.qtyList ? JSON.parse(matched.qtyList) : [];
      } catch (e) {
        console.warn('Invalid qtyList format:', matched.qtyList);
        bags = [];
      }

      const totalBags = bags.length;

     
       setPreviousStatus(
        `Already collected from this farmer ==>    No. of Bags: ${totalBags}  Bag List: ${bags.join(', ')}`
      );
    } else {
      setPreviousStatus('No previous data for this farmer on selected date.');
    }
  } catch (err) {
    console.error('Error fetching collecttea data:', err);
    setPreviousStatus('Could not fetch previous data.');
  }
};


  const resetForm = () => {
    const today = new Date().toISOString().split('T')[0];
    setFormData(prev => ({
      ...prev,
      date: today,
      time: '',
      name: '',
      area: '',
      tare: 8,
      water: 0,
      stick: 0,
      price: 21,
      farmid: '',
      netweight: 0,
      ph: ''
    }));
    setFarmerQuery('');
    setQtyList([{ qty: '' }]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const submissionData = {
      farmid: formData.farmid,
      date: formData.date,
      qtyList: qtyList.map(q => parseFloat(q.qty)),
      tare: formData.tare,
      water: formData.water,
      stick: formData.stick,
      price: formData.price,
      time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
      name: formData.name,
      empid: formData.empid,
      area: formData.area,
      ph: formData.ph
    };

    const response = await fetch('https://kmtea.onrender.com/api/submit-tea', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(submissionData)
    });

    const data = await response.json();

    if (data.success) {
      const billData = {
        ...data.data,
        ph: formData.ph,
        time: submissionData.time
      };
      navigate('/Bill', { state: billData });
      resetForm();
    } else {
      alert('Submit failed: ' + data.error);
    }
  };

  const filteredFarmers = farmers.filter(f =>
    f.name.toLowerCase().includes(farmerQuery.toLowerCase())
  );

  return (
    <div className="register-container r">
      <div className="overlay">
        <div className="form-container">
          <h2 className="title">Tea Register</h2>
                {/* <div className="previous status" ></div> */}
                <div className="previous status">
  {previousStatus && <p>{previousStatus}</p>}
</div>

                      <form className="form" onSubmit={handleSubmit}>
             <div className="row-group two-columns">
               <div className="input-group fir">
                 <label>Date</label>
                 <input type="date" name="date" value={formData.date} onChange={handleChange} />     
                           </div>
               <div className="input-group fir">
                 <label>Employee</label>
                 <input type="text" value={employeeName} readOnly />
               </div>
             </div>
            <div className="row-group three-columns">
              <div className="input-group">
                <div className="farmer-selector-wrapper" ref={dropdownRef}>
                  <label>Farmer Name</label>
                  <input
                    type="text"
                    placeholder="select farmer..."
                    value={farmerQuery}
                    onChange={(e) => {
                      setFarmerQuery(e.target.value);
                      setShowFarmerDropdown(true);
                    }}
                    onFocus={() => setShowFarmerDropdown(true)}
                  />
                  {showFarmerDropdown && filteredFarmers.length > 0 && (
                    <ul className="dropdown">
                      {filteredFarmers.map((farmer) => (
                        <li key={farmer.farmid} onClick={() => handleFarmerSelect(farmer)}>
                          {farmer.name} ({farmer.farmid})
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
             
              <div className="input-group fir">
                <label>Area</label>
                <input type="text" value={formData.area} readOnly />
              </div>
              <div className="input-group fir">
                <label>Phone</label>
                <input type="text" value={formData.ph} readOnly />
              </div>
            </div>

            <div className="row-group four-columns">
              <div className="input-group">
                <label>Qty (per bag)</label>
                {qtyList.map((item, index) => (
                  <div key={index} className="qty-input-row">
                    <span>Bag {index + 1}:</span>
                    <input
                      type="number"
                      value={item.qty}
                      onChange={(e) => handleQtyChange(index, e.target.value)}
                      required
                    />
                    {qtyList.length > 1 && (
                      <button type="button" onClick={() => removeQtyField(index)}>❌</button>
                    )}
                  </div>
                ))}
                <button type="button" onClick={addQtyField} className="add-btn">＋ Add</button>
              </div>
              <div className="input-group">
                <label>Tare (%)</label>
                <input type="number" name="tare" value={formData.tare} onChange={handleChange} />
              </div>
              <div className="input-group">
                <label>Water</label>
                <input type="number" name="water" value={formData.water} onChange={handleChange} />
              </div>
              <div className="input-group">
                <label>Stick</label>
                <input type="number" name="stick" value={formData.stick} onChange={handleChange} />
              </div>
            </div>

            <div className="row-group single">
              <div className="input-group">
                <label>Net Weight</label>
                <input type="number" value={formData.netweight} readOnly />
              </div>
            </div>

            <button className="submit-btn" type="submit">Submit</button>
          
          </form>
        </div>
      </div>
    </div>
  );
}

export default Registertea;
